import { billOverviewConstants } from '../constants';

import { promiseInstance_authorization } from './config';

import { func_validation } from 'functions';
import { Toaster } from 'components/notification/Toaster';



export const billOverviewActions = {
	getSpecificInvoiceDetails,
};

function getSpecificInvoiceDetails(invoiceId) {
    return dispatch => {
		dispatch(request());
		
		let invoiceId_formatted = "";
		if (func_validation.isNumberValid(invoiceId)) invoiceId_formatted = invoiceId;

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/Invoice/' + invoiceId_formatted)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load invoice details";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: billOverviewConstants.getSpecificInvoiceDetails_request, details }; }
    function success(details) { return { type: billOverviewConstants.getSpecificInvoiceDetails_success, details }; }
    function failure(error) { return { type: billOverviewConstants.getSpecificInvoiceDetails_failure, error }; }
}